import { useEffect } from 'react';

/**
 * Close the topmost open modal when Escape is pressed.
 *
 * react-shared's Modal leaves this to the app: the admin hangs it on a user
 * setting, the portal simply has it on. Mounted once in the layout; renders
 * nothing.
 *
 * @return {null} Nothing is rendered.
 */
const ModalEscape = () => {
  useEffect(() => {
    const handler = (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      const dialogs = document.querySelectorAll('wa-dialog[open]');
      const topmost = dialogs[dialogs.length - 1];

      topmost?.requestClose();
    };

    document.addEventListener('keydown', handler);

    return () => document.removeEventListener('keydown', handler);
  }, []);

  return null;
};

export default ModalEscape;
